import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OperationType } from 'common/constants/sm-constants';
import { GroupDetailListingModel } from 'common/models/page-models/groups/group-details/group-detail-grid-model';
import { GroupDetailModel } from 'common/models/page-models/groups/group-details/group-detail-model';
import { GroupDetailsMetaModel } from 'common/models/page-models/groups/group-details/groups-detail-meta-model';
import { RouteEnvelope, WidgetModel } from 'common/models/utility-models/base-model';
import { GridParams, GridWidgetModel } from 'common/models/utility-models/list-utility.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { StudentListWidgetService } from 'common/widget/groups/student-list-widget.service';

@Injectable({
    providedIn: 'root'
})
export class GroupDetailResolver extends GridResolver<GroupDetailModel, GroupDetailListingModel> {
    constructor(
        protected fs: StudentListWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }


    override initWidget(envelopeType: any, transferData: any, data, meta): WidgetModel {
        const widget = new GridWidgetModel();
        const metaModel = this.pageService.getMetaModel();
        widget.recordPerPage = metaModel.properties?.recordPerPage;
        widget.searchableFeilds = metaModel.properties?.searchableFields;
        // console.log(data,'===============')
        transferData.formData = envelopeType === OperationType.UPDATE ? data : new GroupDetailModel();
        transferData.formMeta = new GroupDetailsMetaModel().getMetaModel();
        // console.log(transferData)
        this.fs.getFilterOptions(transferData.formMeta);
        // console.log(transferData.formData)
        widget.transferData = transferData;
        return widget;
    }

    
    //   private override createRouteEnvelopeFromType(type: any): RouteEnvelope {
    //     const envelope = new RouteEnvelope();
    //     envelope.type = OperationType.UPDATE;        
    
    //     return envelope;
    //   }

      override manageState(): any {
        const envelope = new RouteEnvelope();
        envelope.type = OperationType.UPDATE;
         
        }

      
      
    
}